export default __webpack_public_path__ + "static/media/how1.131eddf9.svg";